import { Routes } from '@angular/router';
import { PagenotFoundComponent } from './pagenot-found/pagenot-found.component';

export const routes: Routes = [
  {
    path: 'pagenotfound',
    component: PagenotFoundComponent,
  }
];
